// extracted by mini-css-extract-plugin
module.exports = {"ErrorPage":"page_ErrorPage__39_yD"};